import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import type { AppDefinition } from '../types';
import { useFavorites } from '../hooks/useFavorites';
import { getAppById } from '../data/apps';
import { EmptyFavorites } from '../components/EmptyFavorites';
import { AppGrid } from '../components/AppGrid';

export default function DashboardPage() {
  const { favs, toggle, isFav } = useFavorites();
  const apps: AppDefinition[] = favs.map(getAppById).filter((a): a is AppDefinition => a != null);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Star className="h-6 w-6 fill-amber-400 text-amber-500" />
        <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">
          Mes applications favorites
        </h2>
      </div>

      {favs.length === 0 ? (
        <EmptyFavorites />
      ) : (
        <AppGrid apps={apps} showStar={false} isFav={isFav} onToggleFav={toggle} />
      )}

      <p className="text-center text-xs text-slate-500 dark:text-slate-400">
        Astuce : cliquez sur <Star className="inline h-3 w-3 align-text-bottom text-amber-500" fill="currentColor" />{' '}
        dans{' '}
        <Link to="/apps" className="font-medium text-orange-600 underline-offset-2 hover:underline">
          Toutes les apps
        </Link>{' '}
        pour personnaliser ce tableau de bord.
      </p>
    </div>
  );
}
